import * as React from 'react';
import type {PopupType} from './store/popups';
import {usePopupStore} from './store/popups';

import { View, Touchable, Icon, rem } from './libs/WebComponents';
import { Props } from './types/types';
import { add_action, remove_action } from './utils/FiltersAndActions';



export const Dialog = (props: Props)=>{
   return (
      <View className='dialog'>
         {props.title?<h3>{props.title}</h3>:null}
         {props.children}
      </View>
   );
}

const Popup = (props: Props)=> {

   props = {
      type: 'dialog',
      dismissible: true,
      ...props
   };

   const [animate, setAnimate] = React.useState('animate');
   const ref = React.useRef(null as null | HTMLDivElement);
   React.useEffect(()=>{
      setTimeout(()=>setAnimate(''),300);
      add_action('getPopupRef', (args)=>{
         args.ref.current= ref.current;
      });
      ()=>{
         remove_action('getPopupRef');
      }
   },[]);

   const _onClosePopup = ()=>{
      setAnimate('animate');
      setTimeout(props.onClose, 300);
   }
   return (
      <View className={'popup-container'}>
         <View ref={ref} className={`popup zoomIn ${animate} ${props.type} `} role="popup">
            {props.children?props.children:<div className="html-content" dangerouslySetInnerHTML={{__html: props.body}} />}
         </View>
         {props.dismissible && !props.closeButton?<Icon name="Close" className="close-button" onPress={_onClosePopup} size={rem(3)} color={props.closeButtonColor?props.closeButtonColor:'var(--bs-body-color)'} style={{zIndex:1100,position:'absolute',top:rem(2),right:rem(2)}} />:null}
         {props.closeButton?props.closeButton:null}
      </View>
      );
   };


const Popups = () => {
   const { popups, removePopup } = usePopupStore();
   const [animate, setAnimate] = React.useState('animate');
   const [oldIndex, setOldIndex] = React.useState(0);

   const _onClose = (g: PopupType)=>{
      const uuid = (g.uuid) ? g.uuid:999;
      removePopup(uuid);
   };

   const _closeLastPopup=(e: any)=>{
      if (!e.target.classList.contains('popups-container')) return;
      const last = Array.isArray(popups) && popups.length>0 ? popups.reduce((acc, current) => current):null;
      if(last) _onClose(last);
   }

   React.useEffect(()=>{
      if (popups.length===0)
      {
         setAnimate('animate');
         setTimeout(()=>setOldIndex(popups.length), 300);
      }else{
         setAnimate('');
         setOldIndex(popups.length);
      }
   },[popups]);
   if (popups.length===0 && oldIndex===0) return null;
   return <Touchable onPress={_closeLastPopup} className={`popups-container ${animate}`}>{popups.map((g)=><Popup key={`popup-${g.uuid}`} {...g} onClose={()=>_onClose(g)}/>)}</Touchable>;
}


export default React.memo(Popups);